exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.newPerson[data-v-7ce55393] {\n  background: #F7F7F7;\n}\n.newPerson .newPerson-detail img[data-v-7ce55393] {\n  width: 100%;\n}", ""]);

// exports
